import { useTranslation } from 'react-i18next';
import { BrandMark } from './BrandMark';

export function SplashScreen({ visible, failed, onRetry }: { visible: boolean; failed?: boolean; onRetry?: () => void }) {
  const { t } = useTranslation('common');
  if (!visible) return null;
  return (
    <div className="splash-screen" role="status" aria-live="polite">
      <span className="splash-glow" aria-hidden="true" />
      <BrandMark size={56} />
      <p className="splash-brand">
        VBB<span>PLAY</span>
      </p>
      {failed ? (
        <div className="splash-fail">
          <p>{t('loadFailed')}</p>
          {onRetry ? (
            <button type="button" className="btn btn-primary btn-compact" onClick={onRetry}>
              {t('retry')}
            </button>
          ) : null}
        </div>
      ) : (
        <p className="splash-status">{t('loading')}</p>
      )}
    </div>
  );
}
